import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getDataWithToken } from "../../../Utils/restUtils";
import { getCompanyList } from "../../../CommonURL";

function CompanyFilter({ setIsCompany, IsCompany, industryId, selectedCompany }) {
  const [customerOptions, setCustomerOptions] = useState([]);

  useEffect(() => {
    if (!industryId) {
      setCustomerOptions([]);
      setIsCompany(null);
      return;
    }

    fetchCompanies(industryId);
  }, [industryId]);
  useEffect(() => {
    if (selectedCompany && customerOptions.length > 0) {
      const company = customerOptions.find(
        (item) => item.value == selectedCompany
      );
      setIsCompany(company || null);
    }
  }, [selectedCompany, customerOptions]);

  const fetchCompanies = async (industryId) => {
    const url = `${getCompanyList}?industry_type_id=${industryId}`;

    const data = await getDataWithToken(url);

    if (data?.status) {
      setCustomerOptions(
        data.data.map(({ id, name, address }) => ({
          value: id,
          label:
            address !== "null" && address !== null
              ? `${name} - ${address}`
              : name,
        })),
      );
    }
  };

  return (
    <Select
      options={customerOptions}
      onChange={setIsCompany}
      value={IsCompany}
      placeholder={industryId ? "Select Company" : "Select Industry First"}
      isClearable
      isDisabled={!industryId}
      className="col-sm-12"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'rgba(95, 15, 64,.2)',
          primary: 'rgba(95, 15, 64,.6)',
          primary50: 'rgba(95, 15, 64,.2)'
        },
      })}
    />
  );
}

export default CompanyFilter;
